import React, { useEffect, useState } from "react";
import { Spinner } from "flowbite-react";

const PNGFromBytes = ({ byteString, className }) => {
  const [imageSrc, setImageSrc] = useState("");

  useEffect(() => {
    const convertByteStringToBlobUrl = (byteString) => {
      try {
        const binaryString = atob(byteString);

        const len = binaryString.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
          bytes[i] = binaryString.charCodeAt(i);
        }

        const blob = new Blob([bytes], { type: "image/png" });

        return URL.createObjectURL(blob);
      } catch (e) {
        console.log(e);
      }
    };

    const url = convertByteStringToBlobUrl(byteString);
    setImageSrc(url);

    return () => {
      URL.revokeObjectURL(url);
    };
  }, [byteString]);

  return (
    <>
      {imageSrc ? (
        <img src={imageSrc} className={className} alt="PNG Image" />
      ) : (
        <Spinner />
      )}
    </>
  );
};

export default PNGFromBytes;
